var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5"},[_c('md-empty-state',{staticClass:"align-middle",attrs:{"md-rounded":"","md-icon":"block","md-label":"Usuario no registrado","md-description":"El usuario no esta inscrito en el Censo."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }